import { useNuxtApp } from '#app'

export const useAlt = () => {
  return useNuxtApp().$alt
}
